import React, { Fragment, useEffect, useState } from "react";
import "./plans.scss";
import {
  Box,
  Button,
  CardMedia,
  Container,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import closex from "../../assets/images/x.png";
import { connect } from "react-redux";
import SnackBar from "../../atoms/snackBar";
import { cancelSubscriptionApi, getPaymentHistoryListApi, getProgramListApi, getUserData, paymentCheckoutURLApi } from "../../redux/action/user";
import "react-quill/dist/quill.snow.css";
import CenterLoading from "../../component/core/CenterLoading";
import CloseIcon from "@mui/icons-material/Close";

const PlanSubscription = (props) => {
  const [desc, setDesc] = useState("");
  const [descModal, setDescModal] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [selectedPgrm, setSelectedPgrm] = useState({});
  const [loading, setLoading] = useState(false)
  const [programList, setProgramList] = useState([]);
  const [paymentHistoryList, setPaymentHistoryList] = useState([]);
  const [subscriptionCancelModal, setSubscriptionCancelModal] = useState(false)
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
  const [openSnackBar, setOpenSnackBar] = useState({
    open: false,
    message: '',
    severity: ''
  })

  const getProgramList = async () => {
    try {
      const res = await getProgramListApi();
      setProgramList(res?.data?.data?.programList || []);
    } catch (error) {
      // console.error("Error in getProgramList:", error);
    }
  };

  const getPaymentHistoryList = async () => {
    try {
      const res = await getPaymentHistoryListApi();
      setPaymentHistoryList(res?.data?.data || []);
    } catch (error) {
      // console.error("Error in getPaymentHistoryList:", error);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      await Promise.all([getProgramList(), getPaymentHistoryList()]);
    } catch (err) {
      // console.error("Error loading data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const subscriptionList = programList?.filter((item) => item.isSubscription === true);

  const programsList = programList?.filter((item) => !item.isSubscription);

  // Handle the expansion of the accordion
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Style for the modal container
  const modalStyle = {
    overflow: "hidden",
    position: "relative",
    // height: "80vh",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxHeight: "90vh",
    backgroundColor: "white",
    boxShadow: 24,
    padding: "20px",
    // overflowY: "auto", // Makes the content scrollable
    borderRadius: "8px",
    ".close-pop-wrap": {
      top: "0px",
      right: "0px",
      position: "sticky",
      padding: "10px",
      textAlign: "right",
      img: {
        width: "24px",
        height: "24px",
      },
    },
  };


  const isPlanPurchased = (plan) => {
    if (plan.isSubscription) {
      const subs = Array.isArray(props.user?.subscriptions) ? props.user.subscriptions : [];
      const legacy = props.user?.subscription && typeof props.user.subscription === "object"
        ? props.user.subscription
        : null;

      return (
        subs.some(
          (s) => s?.isSubscription && String(s?.programSubscriptionId) === String(plan.ID)
        ) ||
        (legacy?.isSubscription &&
          String(legacy?.programSubscriptionId) === String(plan.ID))
      );
    } else {
      return (
        props.user.programPurchased &&
        props.user.programPurchased.some(
          (purchase) => purchase.programSubscriptionId === plan.ID
        )
      );
    }
  };


  const handlePayment = async (ele) => {
    const payload = {
      ID: ele.ID,
      coponCode: localStorage.getItem("couponCode") || null
    }
    try {
      const res = await paymentCheckoutURLApi(payload);
      window.location.href = res.data.data.url;
    } catch (error) {
      setOpenSnackBar({
        open: true,
        message: error?.message,
        severity: 'error'
      })
      getProgramList()
    }
  };

  const handleSeeMore = (description) => {
    setDesc(description);
    setDescModal(true);
  };

  const passesVitalityPortalListingRule = (plan) => {
    if (plan?.showOnVitalityPortal === false) {
      return isPlanPurchased(plan);
    }
    return true;
  };

  const handleActivePlansAndSubscription = (plans) => {
    if (!passesVitalityPortalListingRule(plans)) return false;
    return isPlanPurchased(plans) || plans?.status === "1";
  };

  const handleCancelSubscription = async (id, isCancelling) => {
    setLoading(true)
    try {
      const res = await cancelSubscriptionApi(id || selectedSubscriptionId, isCancelling);
      setOpenSnackBar({
        open: true,
        message: res?.data?.message,
        severity: 'success'
      })

      await getProgramList();
      await props.getUserData(localStorage.getItem("userKey"));
      await getPaymentHistoryList()

    } catch (error) {
      setOpenSnackBar({
        open: true,
        message: error?.message,
        severity: 'error'
      })
    } finally {
      setSubscriptionCancelModal(false);
      setLoading(false)
    }
  };

  const isPlanActive = (ele) => {
    const endDate = ele?.expirationTime;

    const today = new Date();
    const expDate = new Date(endDate);
    return expDate > today;
  };
  const subscriptionPaymentHistory = paymentHistoryList?.filter(
    (item) => item.subscriptionId
  );

  const getLatestSubscriptionHistoryForPlan = (planId) => {
    const matches = subscriptionPaymentHistory?.filter((h) => {
      const bySubscriptionId =
        h?.subscriptionId != null && String(h.subscriptionId) === String(planId);
      const byProgramSubscriptionId =
        h?.programSubscriptionId != null && String(h.programSubscriptionId) === String(planId);
      const byJoinId =
        h?.js_programSubscription?.ID != null &&
        String(h.js_programSubscription.ID) === String(planId);
      return bySubscriptionId || byProgramSubscriptionId || byJoinId;
    }) || [];

    return matches
      .slice()
      .sort((a, b) => {
        const aTime = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
        const bTime = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
        if (aTime !== bTime) return bTime - aTime;
        return (Number(b?.ID) || 0) - (Number(a?.ID) || 0);
      })[0];
  };


  const cards = (ele) => {
    const latestHistory = ele?.isSubscription
      ? getLatestSubscriptionHistoryForPlan(ele.ID)
      : null;

    return (
      <Grid item xs={12} sm={6} md={4} key={ele.ID}>
        <div className="plan-block">
          <div className="plan-title" style={{ margin: '15px 0px' }}>
            <Typography variant="h6" className="white-color avenir-bold">
              {ele?.name}
            </Typography>
          </div>
          <div className="plan-detail" style={{ textAlign: "center" }}>
            <div className="ImgWrap">
              <CardMedia
                component="img"
                alt={ele.name}
                image={ele.imageUrl}
                title={ele.name}
              />
            </div>

            <Typography className="plan-desc" px={2}>
              {ele.description && ele.description.length > 120 ? (
                <>
                  {ele.description.slice(0, 120)}...
                  <span
                    className="see-more"
                    onClick={() => {
                      handleSeeMore(ele.description);
                      setSelectedPgrm(ele);
                    }}
                    style={{ cursor: "pointer", color: "blue" }}
                  >
                    See more
                  </span>
                </>
              ) : (
                ele.description
              )}
            </Typography>
            <Typography
              className="plan-desc"
              style={{ textDecoration: "underline", cursor: 'pointer' }}
              onClick={() => {
                handleSeeMore(ele.description);
                setSelectedPgrm(ele);
              }}
            >
              Details
            </Typography>
          </div>
          <div className="BuyNowOption">
            <div className="TextWrap">
              <Typography>
                Duration:{" "}
                {ele.isSubscription
                  ? (() => {
                    const interval = (ele.interval || "").toString().toLowerCase();
                    const count = Number(ele.duration) || 1;
                    if (interval === "daily") return count <= 1 ? "Daily" : `${count} Days`;
                    if (interval === "weekly") return count <= 1 ? "Weekly" : `${count} Weeks`;
                    if (interval === "monthly") {
                      if (count === 6) return "6 Monthly";
                      return count <= 1 ? "Monthly" : `${count} Months`;
                    }
                    if (interval === "yearly" || interval === "annually" || interval === "annual") {
                      return count <= 1 ? "Annually" : `${count} Years`;
                    }
                    // Fallback: show the interval string if backend sends a new value
                    return interval ? interval[0].toUpperCase() + interval.slice(1) : "Subscription";
                  })()
                  : "Lifetime"}
              </Typography>
              <Typography>
                Price:{" "}
                {`$${ele.amount} ${ele.currency && ele.currency.toUpperCase()}`}
              </Typography>
            </div>
            <Box sx={{ display: 'flex', gap: '15px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  if (isPlanPurchased(ele) && !ele?.isSubscription && ele?.url) {
                    window.open(ele.url, "_blank");
                  } else if (
                    isPlanPurchased(ele) &&
                    ele.isSubscription &&
                    latestHistory?.orderStatus !== "CANCELLED" &&
                    isPlanActive(latestHistory)
                  ) {
                    setSelectedSubscriptionId(latestHistory?.ID);
                    setSubscriptionCancelModal(true);
                  } else if (
                    isPlanPurchased(ele) &&
                    ele.isSubscription &&
                    latestHistory?.orderStatus === "CANCELLED" &&
                    isPlanActive(latestHistory)
                  ) {
                    handleCancelSubscription(latestHistory?.ID, false);
                  } else {
                    handlePayment(ele);
                  }
                }}
                className="buy-now-button"
                disabled={isPlanPurchased(ele) && ele?.isCorporate}
                sx={{
                  backgroundColor:
                    ele.isSubscription &&
                      isPlanPurchased(ele) &&
                      latestHistory?.orderStatus !== "CANCELLED" &&
                      isPlanActive(latestHistory)
                      ? "grey !important"
                      : "#e29c2e !important",
                  cursor: "pointer",
                }}
              >
                {ele?.isSubscription
                  ? isPlanPurchased(ele)
                    ? latestHistory?.orderStatus === "CANCELLED" &&
                      isPlanActive(latestHistory)
                      ? "Renew"
                      : "Cancel"
                    : "Subscribe"
                  : isPlanPurchased(ele) && ele?.isCorporate
                    ? "Active"
                    : "Subscribe"}
              </Button>

            </Box>
          </div>
        </div>
      </Grid>
    )
  }
  return (
    <>
      {loading ? (
        <CenterLoading open={loading} />
      ) : (
        <Container className="plans">
          {subscriptionList?.filter(handleActivePlansAndSubscription)?.length > 0 && (
            <Fragment>
              <Typography
                sx={{
                  padding: "10px",
                  color: "#fff",
                  backgroundColor: "#121c1f",
                  borderRadius: "10px",
                  width: "97%",
                  textAlign: 'center',
                  textTransform: 'uppercase',
                  fontWeight: 'bold',
                }}
              >
                Subscriptions
              </Typography>
              <Grid container spacing={2} marginTop={1} marginBottom={4} justifyContent="center">
                {subscriptionList?.filter(handleActivePlansAndSubscription)?.map((ele, index) => cards(ele, index))}
              </Grid>
            </Fragment>
          )}
          {programsList?.filter(handleActivePlansAndSubscription)?.length > 0 && (
            <Fragment>
              <Typography
                sx={{
                  padding: "10px",
                  color: "#fff",
                  backgroundColor: "#121c1f",
                  borderRadius: "10px",
                  width: "97%",
                  textAlign: 'center',
                  textTransform: 'uppercase',
                  fontWeight: 'bold'
                }}
              >
                Programs
              </Typography>
              <Grid container spacing={2} marginTop={1} justifyContent="center">
                {programsList?.filter(handleActivePlansAndSubscription)?.map((ele, index) => cards(ele, index))}
              </Grid>
            </Fragment>
          )}
          {(subscriptionList?.filter(handleActivePlansAndSubscription)?.length === 0 &&
            programsList?.filter(handleActivePlansAndSubscription)?.length === 0) && (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="66vh"
                sx={{ textAlign: "center", flex: "auto" }} // MUI sx prop for styling
              >
                <Typography variant="h6">Stay tuned to check the available programs and subscriptions.</Typography>
              </Box>
            )}
        </Container>
      )}
      <Modal open={descModal} onClose={() => setDescModal(false)}>
        <Box sx={modalStyle}>
          <div className="close-pop-wrap">
            <img
              src={closex}
              alt={closex}
              onClick={() => setDescModal(false)}
            ></img>
          </div>
          <div>
            {selectedPgrm && (
              <HtmlContent rawHtmlContent={selectedPgrm.summary} />
            )}
          </div>
        </Box>
      </Modal>
      <Modal
        open={subscriptionCancelModal}
        onClose={() => setSubscriptionCancelModal(false)}
      >
        <Box sx={{ ...cancelSubscriptionModalStyle }} width={"45%"} maxWidth={"600px"} minWidth={"350px"}>
          {/* Modal Header */}
          <box className="close-pop-wrap" >
            <Box className="Heading">
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#fff" }}
              >
                Cancel Subscription
              </Typography>
            </Box>
            <CloseIcon onClick={() => setSubscriptionCancelModal(false)} className="CloseImg" />
          </box>

          {/* Modal Body */}
          <div className="ContentWrapper">
            <Typography>
              You will continue to enjoy the benefits of being a subscribed member till the end of the current billing cycle. Thereafter, your account will have limited features until you renew again. Do you wish to proceed?
            </Typography>
          </div>

          {/* Modal Actions */}
          <Box className="modal-actions" display="flex" justifyContent="end" mt={2} marginRight={2}>
            <Button variant="outlined" color="secondary" sx={{ marginRight: 2 }} onClick={() => handleCancelSubscription(selectedSubscriptionId, true)}>
              Yes
            </Button>
            <Button
              variant="contained"
              sx={{
                fontWeight: "bold",
                fontSize: "16px",
                background: '#E29C2E',
                '&:hover': {
                  background: '#C07D1A'
                }
              }}
              onClick={() => setSubscriptionCancelModal(false)}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>


      <SnackBar
        open={openSnackBar.open}
        message={openSnackBar.message}
        severity={openSnackBar.severity}
        handleCloseSnackBar={() => {
          setOpenSnackBar({
            open: false,
            message: '',
            severity: ''
          })

        }}
      />
    </>
  );
};

PlanSubscription.propTypes = {};
PlanSubscription.defaultProps = {};

const actionCreators = {
  // getProgramList,
  getUserData,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators
)(PlanSubscription);

const HtmlContent = ({ rawHtmlContent }) => {
  // Decode the raw HTML content
  const decodedHtml = decodeHtmlEntities(rawHtmlContent);

  return <div dangerouslySetInnerHTML={{ __html: decodedHtml }} />;
};

export function decodeHtmlEntities(text) {
  const doc = new DOMParser().parseFromString(text, "text/html");
  return doc.documentElement.textContent || doc.documentElement.innerText;
}


const cancelSubscriptionModalStyle = {
  overflow: "hidden",
  position: "relative",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90vh",
  backgroundColor: "white",
  boxShadow: 24,
  pb: 2,
  borderRadius: "8px",
  ".close-pop-wrap": {
    top: "0px",
    right: "0px",
    position: "sticky",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#112225",
    img: {
      width: "24px",
      height: "24px",
    },
  },
  ".Heading": {
    display: "flex",
    alignItems: "center",
    h2: {
      mb: 0,
      color: "#fff",
    },
    svg: {
      mr: 1,
      width: "20px",
      height: "20px",
    },
  },
  ".CloseImg": {
    opacity: 1,
    borderRadius: "50%",
    p: "2px",
    border: "1px solid #fff",
    fontSize: "0.7rem",
    path: {
      fill: "#fff",
    },
  },
  ".ContentWrapper": {
    p: 2,
  },
};